<template>
  <div>
    <div class="flex leftTop">
      <div class="flex-sub">
        <div class="top1">人流量</div>
        <div class="top3">{{ toFixed(13596) }} <span>人</span></div>
      </div>
      <div class="flex-sub">
        <!-- <div class="top1">常住人口数量</div>
        <div class="top2">{{ toFixed(dataVal.permanent) }} <span>人</span></div> -->
      </div>
    </div>
    <Echart id="leftTop" :options="options" height="175px" v-if="pageflag" ref="charts" />
    
  </div>
</template>

<script>

export default {
  
  data() {
    return {
      pageflag: true,
      options: {},
      timer: null,
    }
  },
  props: {
	  dataVal: {
	        type: Object,
	        default: () => ({})
	      }
  },
  watch: {
	  dataVal: {
		  handler(newData) {
			  this.$nextTick(() => {
				  this.getData()
			  })
		  },
		  immediate: true,
		  deep: true
	  }
  },
  mounted() {
    
    this.getData()
	console.log(this.dataVal)
  },
  beforeDestroy() {
    this.clearData()
  },
  methods: {
   
    toFixed(val) {
      let num = parseFloat(val).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let actualNum = num.split(".");
      if (actualNum[1] > 0) {
        return num;
      } else {
        return actualNum[0];
      }
    },
    getData() {
      this.pageflag = true
        ////////////////////////////

let xLabel = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];
let L0 = ["1240", "3460", "2122", "685", "4650", "5310", "1544", "960", "3122", "1785", "850",
					"1740"
				];
// let L0 = this.dataVal.visitor;
// let L1 = ['50', '30', '72', '35', '80', '60','72', '35', '80', '60', '72', '35'];

this.options =  {
    tooltip: {
        trigger: 'axis',
    },
    legend: {
        align: 'left',
        right: '30px',
        type: 'plain',
        top:'1px',
        textStyle: {
            color: '#7ec7ff',
            fontSize: 12,
        },
        itemGap: 25,
        itemWidth: 18,
        // icon:'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
    },
    grid: {
        top: '23px',
        left: '80px',
        right: '30px',
        bottom: '40px',
        // containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: false,
            axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                    color: '#233653',
                },
            },
            axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                    color: '#7ec7ff',
                    padding: 10,
                    fontSize: 12,
                },
                formatter: function (data) {
                    return data;
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#192a44',
                },
            },
            axisTick: {
                show: false,
            },
            data: xLabel,
        },
    ],
    yAxis: [
        {
            nameTextStyle: {
                color: '#7ec7ff',
                fontSize: 12,
                padding: 10,
            },
            min: 0,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#192a44',
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#233653',
                },
            },
            axisLabel: {
                show: true,
                textStyle: {
                    color: '#7ec7ff',
                    padding: 10,
                },
                formatter: function (value) {
                    if (value === 0) {
                        return value;
                    }
                    // return value+'%';
                    return value;
                },
            },
            axisTick: {
                show: false,
            },
        },
    ],
    series: [
        {
            name: '访客信息',
            type: 'line',
            symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            lineStyle: {
              width: 2,
                    color: 'rgba(84,131,255,1)', // 线条颜色
                borderColor: 'rgba(0,0,0,.4)',
            },
            itemStyle: {
                color: 'rgba(84,131,255,1)',
            },
            tooltip: {
                show: true,
            },
            areaStyle: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new this.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                            {
                                offset: 0,
                                color: 'rgba(84,131,255,.3)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(84,131,255, 0)',
                            },
                        ],
                        false
                    ),
                    shadowColor: 'rgba(25,163,223, 0.5)', //阴影颜色
                    shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
             
            },
            data: L0,
        },
    ],
};
        ///////////////////////////
    },
    clearData() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  .flex-sub {
    flex: 1;
  }
}
.leftTop {
  padding: 0 10px 10px;
  .top1 {
    height: 40px;
    background-size: 100% 100%;
    line-height: 40px;
    padding-left:30px;
    background-image: url(../assets/img1.png);
    background-repeat: no-repeat;
    color: #21e3ff;
    font-weight: 700;
    font-size: 16px;
  }
  .top2 {
    color: #ff9407;
    padding-left:30px;
    font-size: 26px;
    span {
      font-size:14px;
    }
  }
  .top3 {
    color: #24ff95;
    padding-left:30px;
    font-size: 26px;
    span {
      font-size:14px;
    }
  }

}
</style>